import React from 'react';
import BasicTemplate from './BasicTemplate.js'

function Inspected(props) {
    return (
        <BasicTemplate>
            <h3><b>Gracias por tomarse el tiempo de llenar el formulario.</b></h3>
            <p>En breve un representante se comunicará con usted.</p>
        </BasicTemplate>
        );
};
export default Inspected;


/** WEBPACK FOOTER **
 ** ./src/components/Inspected.js
 **/